import { atom } from "recoil";

export const FetchingUrlsAtom = atom<string[]>({
  key: "FetchingUrlsAtom",
  default: [],
});
